const DotLoader = ({ color, className }) => {
	return (
		<div
			className={`dot-loader dot-loader-${color}` + (className ? ` ${className}` : "")}
			data-testid="dotloader"
		>
			<div className={`dot-loader-dot dot-loader-one dot-loader-dot-${color}`}>
				<span className="dot-loader-square"></span>
			</div>
			<div className={`dot-loader-dot dot-loader-two dot-loader-dot-${color}`}>
				<span className="dot-loader-square"></span>
			</div>
			<div className={`dot-loader-dot dot-loader-three dot-loader-dot-${color}`}>
				<span className="dot-loader-square"></span>
			</div>
		</div>
	);
};

DotLoader.defaultProps = {
	color: "medium-cool-gray",
	className: ""
};

export default DotLoader;
